import React, { useContext, useCallback, useState } from "react";
import AppContext from "../../store/app-context";
import Button from "../UI/Button";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';

import styles from "./QuoteDetailsHeader.module.css";

const QuoteDetailsHeader = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAPIError, setIsAPIError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Error fetching data...');

  const appCtx = useContext(AppContext);

  let label_quoteId = 'Quote ID';
  let label_WebRef = 'Web Reference ID';
  let label_dateQuoteRequested = 'Date Quote Requested';
  let label_dateQuoteNeeded = 'Date Quote Needed';
  let label_status = 'Status';
  let label_comments = 'Comments';
  let label_quoteInfo = 'Quote Information';
  let label_acctNo = 'Account Number';
  let label_pPlan = 'Purchase Plan';
  let label_email = 'Email';
  let label_purposeOfQuote = 'Purpose of Quote';
  let label_grantApp = 'Grant Application';
  let label_newLab = 'New Lab';
  let label_salesRep = 'Sales Representative';
  let label_pp_immediately="Immediately";
  let label_pp_1_3_months="1 to 3 months";
  let label_pp_6_months="6 months";
  let label_pp_more_than_6_months="More than 6 months";
  let label_fetch_error = 'Sorry, we are experiencing issues. Please try again later.';

  if(appCtx && appCtx.bioradResources){
    label_quoteId = appCtx.bioradResources.QuoteID ? appCtx.bioradResources.QuoteID : 'Quote ID ';
    label_WebRef = appCtx.bioradResources.WebReferenceID ? appCtx.bioradResources.WebReferenceID : 'Web Reference ID ';
    label_dateQuoteRequested = appCtx.bioradResources.Date_Quote_Requested ? appCtx.bioradResources.Date_Quote_Requested : 'Date Quote Requested';
    label_dateQuoteNeeded = appCtx.bioradResources.Date_Quote_Needed ? appCtx.bioradResources.Date_Quote_Needed : 'Date Quote Needed';
    label_status = appCtx.bioradResources.Status_col_Header ? appCtx.bioradResources.Status_col_Header : 'Status';
    label_comments = appCtx.bioradResources.Comments ? appCtx.bioradResources.Comments : 'Comments';
    label_quoteInfo = appCtx.bioradResources.Quote_Details_Information ? appCtx.bioradResources.Quote_Details_Information : 'Quote Information';
    label_acctNo = appCtx.bioradResources.AccountNumber ? appCtx.bioradResources.AccountNumber : 'Account Number';
    label_pPlan = appCtx.bioradResources.Purchase_Plan ? appCtx.bioradResources.Purchase_Plan : 'Purchase Plan';
    label_email = appCtx.bioradResources.EmailAdd ? appCtx.bioradResources.EmailAdd : 'Email';
    label_purposeOfQuote = appCtx.bioradResources.Purpose_Of_Quote ? appCtx.bioradResources.Purpose_Of_Quote : 'Purpose of Quote';
    label_grantApp = appCtx.bioradResources.Grant_Application ? appCtx.bioradResources.Grant_Application : 'Grant Application';
    label_newLab = appCtx.bioradResources.New_Lab ? appCtx.bioradResources.New_Lab : 'New Lab';
    label_salesRep = appCtx.bioradResources.Sales_Representative ? appCtx.bioradResources.Sales_Representative : 'Sales Representative';
    label_pp_immediately= appCtx.bioradResources.PP_Immediately ? appCtx.bioradResources.PP_Immediately : "Immediately";
    label_pp_1_3_months= appCtx.bioradResources.PP_1_3_Months ? appCtx.bioradResources.PP_1_3_Months : "1 to 3 months";
    label_pp_6_months= appCtx.bioradResources.PP_6_Months ? appCtx.bioradResources.PP_6_Months : "6 months";
    label_pp_more_than_6_months= appCtx.bioradResources.PP_More_Than_6_Months ? appCtx.bioradResources.PP_More_Than_6_Months : "More than 6 months";
    label_fetch_error = appCtx.bioradResources["bad-request"] ? appCtx.bioradResources["bad-request"] : 'Sorry, we are experiencing issues. Please try again later.';
  }

  const quote = props.quote;
  const referenceNumber = quote.quoteId
    ? label_quoteId + quote.quoteId
    : label_WebRef + quote.webReference;

  const getFileNameFromContentDispostionHeader = (header, defaultFileName) => {
    let contentDispostion = header.split(';');
    const fileNameToken = 'filename=';

    let fileName = defaultFileName;
    for (let thisValue of contentDispostion) {
        if (thisValue.trim().indexOf(fileNameToken) === 0) {
            fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''));
            break;
        }
    }

    return fileName;
  }

  const downloadPDFHandler = useCallback(async () => {
    setIsLoading(true);
    const getPDFURL = '/quoteservices/rfqs/pdf/' + quote.webReference + '/' + quote.quotePDFName;
    const response = await fetch(getPDFURL, { method: 'GET'} );

    if (!response.ok) {
      let errorMsg = label_fetch_error;
      const data = await response.json();
      if(data && data.status === 'fail'){
        errorMsg = data.message;
      }
      setIsAPIError(true);
      setErrorMsg(errorMsg);
      setIsLoading(false);

    }else{
      /*const data = await response.json();
      if(data && data.status === 'fail'){
        setIsAPIError(true);
        setErrorMsg(data.message);
      }else{

      }*/
      const fileName = getFileNameFromContentDispostionHeader(response.headers.get('content-disposition'), quote.quotePDFName);
      response.blob().then(blob => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = fileName;
        alink.click();
    })
      setIsLoading(false);
    }
    setIsLoading(false);
  },[]);

  // Adobe Analytics: userView and pageView
  SetAnalyticsData();

  let purchasePlanText = label_pp_immediately;
  if(quote?.purchasePlan){
    if(quote.purchasePlan === 'PP_1_3_Months'){
      purchasePlanText = label_pp_1_3_months;
    }else if(quote.purchasePlan === 'PP_6_Months'){
      purchasePlanText = label_pp_6_months;
    }else if(quote.purchasePlan === 'PP_More_Than_6_Months'){
      purchasePlanText = label_pp_more_than_6_months;
    }
  }

  return (
    <>
      <div className={styles.heading_2}>{referenceNumber}</div>
      <div className={styles.header_text}>
        <div className={styles.header__toplevel}>
          {quote.formattedDateQuoteRequested && (
            <>
              <div className={styles.dateQuoteReq}>
              <span><strong>{label_dateQuoteRequested}:</strong> </span>
              <span>{quote.formattedDateQuoteRequested}</span>
              </div>
            </>
          )}
          {quote.formattedDateQuoteNeeded && (
            <>
            <div className={styles.dateQuoteReq}>
              <span><strong>{label_dateQuoteNeeded}:</strong></span>
              <span>{quote.formattedDateQuoteNeeded}</span>
              </div>
            </>
          )}
          <div className={styles.dateQuoteReq}>
          <span><strong>{label_status}:</strong> </span>
          <span>{quote.quoteStatus}</span>
          {quote.quoteId && (<Button onClick={downloadPDFHandler}>PDF</Button>)}
          </div>
        </div>
        {quote.comments && (
          <div className={styles.comments}>
            <span><strong>{label_comments}</strong> </span>
            <span>{quote.comments}</span>
          </div>
        )}
        {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
        {isAPIError && <p>{errorMsg}</p>}
      </div>
      <div className={styles.quotebox}>
        <div className={styles.heading_2}>{label_quoteInfo}</div>
        <div className={styles.header_text}>
          <div className={styles.an_pp_qq}>
          {quote.soldToAccountNumber && (
              <>
              <div className={styles.header_text__child}>
                <span><strong>{label_acctNo}</strong> </span>
                <span>{quote.soldToAccountNumber}</span>
                </div>
              </>
            )}

            {quote.purchasePlan && (
              <>
              <div className={styles.header_text__child}>
               <span><strong>{label_pPlan}</strong> </span>
                <span>{purchasePlanText}</span>
                </div>
              </>
            )}
            {quote.userEmail && (
              <>
              <div className={styles.header_text__child}>
                <span><strong>{label_email}</strong> </span>
                <span>{quote.userEmail}</span>
                </div>
              </>
            )}
          </div>
          <div className={styles.e_pq_sr}>
          <div className={styles.header_text__child}>
            {(quote.isGrantApplication || quote.isNewLab) &&
            <span><strong>{label_purposeOfQuote}</strong> </span> }
            {quote.isGrantApplication && <span>{label_grantApp}</span>}
            {quote.isNewLab && <span>{label_newLab}</span>}</div>
            {quote.salesRepName && quote.salesRepEmail && (
              <>
              <div className={styles.header_text__child}>
                <span><strong>{label_salesRep}</strong> </span>
                <span><a href={'mailto:' + quote.salesRepEmail}>{quote.salesRepName}</a></span>
                </div>
              </>
            )}
            </div>
        </div>
      </div>
    </>
  );
};

export default QuoteDetailsHeader;
